import { BaseAutoTestStep } from './base';
import { errOrData, mergeEithers } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class CheckPointsAutoTestStep extends BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    parseInputData(data) {
        return data;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getDataToSave(context) {
        const errs = [];
        if (context.totalWeight <= 0) {
            errs.push('The total weight of all steps before a checkpoint must be positive.');
        }
        if (context.remainingSteps <= 0) {
            errs.push('The last step of a suite may not be a checkpoint.');
        }
        if (this.data.minPoints < 0) {
            errs.push('The minimal percentage must be greater than 0.');
        }
        else if (this.data.minPoints > 1) {
            errs.push('The mimimal percentage must be less than or equal to 100.');
        }
        const extra = errOrData(errs, { type: this.type, data: this.data, weight: 0 });
        return mergeEithers(this._baseGetDataToSave(), extra);
    }
}
